import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface FeedbackItem {
  id: string;
  business_id: string;
  business_name?: string;
  feedback_type: 'suggestion' | 'complaint' | 'review';
  title: string;
  content: string;
  rating?: number;
  category_food?: number;
  category_service?: number;
  category_ambience?: number;
  category_value?: number;
  status: 'pending' | 'read' | 'responded' | 'archived';
  is_public: boolean;
  order_id?: string;
  business_response?: string;
  responded_at?: string;
  created_at: string;
}

export interface CreateFeedbackRequest {
  business_id: string;
  feedback_type: 'suggestion' | 'complaint' | 'review';
  title: string;
  content: string;
  rating?: number;
  category_food?: number;
  category_service?: number;
  category_ambience?: number;
  category_value?: number;
  order_id?: string;
}

export interface FeedbackFilters {
  feedback_type?: string;
  business_id?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  private readonly API_URL = '/api/v1/feedback';

  constructor(private http: HttpClient) {}

  create(data: CreateFeedbackRequest): Observable<any> {
    return this.http.post(this.API_URL, data);
  }

  getMyFeedback(filters: FeedbackFilters = {}): Observable<{ success: boolean; feedback: FeedbackItem[] }> {
    let params = new HttpParams();
    if (filters.feedback_type) params = params.set('feedback_type', filters.feedback_type);
    if (filters.business_id) params = params.set('business_id', filters.business_id);
    if (filters.status) params = params.set('status', filters.status);
    if (filters.limit) params = params.set('limit', filters.limit.toString());
    if (filters.offset) params = params.set('offset', filters.offset.toString());

    return this.http.get<{ success: boolean; feedback: FeedbackItem[] }>(this.API_URL, { params });
  }

  archive(feedbackId: string): Observable<any> {
    return this.http.put(`${this.API_URL}/${feedbackId}/archive`, {});
  }
}
